import { render, staticRenderFns } from "./DistributionMember.vue?vue&type=template&id=55672e76&scoped=true"
import script from "./DistributionMember.vue?vue&type=script&lang=js"
export * from "./DistributionMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55672e76",
  null
  
)

export default component.exports